import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M19 6C19 6.55 18.55 7 18 7C17.45 7 17 6.55 17 6C17 5.45 17.45 5 18 5C18.55 5 19 5.45 19 6ZM22 2V12L12 22L2 12L12 2H22ZM11 13H5.83L11 18.17V13ZM11 5.83L5.83 11H11V5.83ZM20 4H13V18.17L20 11.17V4Z" fill={ fill || 'currentColor' } />
    </svg>
);
